<template>
  <div data-app class="navigate-container">
    <button @click="handleBookCourse">
      <img :src="icons.CourseIcon" class="navigate-icon" />
      <p class="navigate-text">{{ $t("bookCourse") }}</p>
    </button>

    <button @click="handleShopping">
      <img :src="icons.ShoppingIcon" class="navigate-icon" />
      <p class="navigate-text">{{ $t("shopping") }}</p>
    </button>

    <div class="empty" />
    <div class="text-center">
      <v-dialog v-model="showDialog" width="320">
        <v-card>
          <v-card-text
            style="font-weight: bold;
              height: 70px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 20px;
              padding-bottom: 0;"
            class="text-h5 grey lighten-2 text-center pt-10 fw-bold"
          >
            {{ $t("comingSoon") }}
          </v-card-text>

          <v-card-actions style="justify-content: center;">
            <v-btn @click="onClose" class="text-center button" color="#00aea9">
              <span class="c-white-text"> OK </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CourseIcon from "@/assets/img/navigate/booking.svg";
import ShoppingIcon from "@/assets/img/navigate/shop.svg";

export default {
  created() {},
  data() {
    return {
      icons: {
        CourseIcon,
        ShoppingIcon
      },
      showDialog: false
    };
  },
  watch: {
    showDialog: function(newValue, old) {
      if (!newValue) {
        this.onClose();
      }
    }
  },
  methods: {
    handleBookCourse() {
      const newPath = this.$router?.history?.current?.fullPath.replace(
        "/navigate",
        "/wap"
      );
      window.location.href = newPath;
    },
    handleShopping() {
      console.log("sssssssssssssss");
      this.showDialog = true;
      // const newPath = this.$router?.history?.current?.fullPath.replace(
      //   "/navigate",
      //   "/vietin-shop"
      // );
      // window.location.href = newPath;
    },
    onClose() {
      this.showDialog = false;
    }
  }
};
</script>
<style scoped>
.navigate-container {
  display: flex;
  justify-content: space-evenly;
  background-image: url("~@/assets/img/navigate/simple.jpg");
  background-size: cover;
  background-position: left;
  background-repeat: no-repeat;

  /* align-items: center; */

  padding-top: 10vw;
  align-items: flex-start;

  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.navigate-button {
  background-color: #00aea9;
  width: 20vw;
  min-width: 100px;
  min-height: 100px;
  height: 20vw;
  border-radius: 8px;
  opacity: 0.9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.navigate-button:hover {
  opacity: 1;
}

.navigate-button:active {
  opacity: 0.9;
}

.navigate-text {
  margin-top: 1vw;
  margin-bottom: 0;
  font-weight: 400;
  color: #666;
  font-size: 3vw;
}

.navigate-icon {
  width: 15vw;
  height: 15vw;
}

.empty {
  width: 20vw;
}

.button {
  border-radius: 100px;
  width: 90px;
}
</style>
